import React from "react";
import { ArrowUp, ArrowUpRight } from "lucide-react";
import { LocalClock } from "./LocalClock";
import { Logo } from "./Logo";
import { links } from "../data/portfolio";
const index = [{
  label: "Work",
  href: "/#work"
}, {
  label: "About",
  href: "/#about"
}, {
  label: "Services",
  href: "/#services"
}, {
  label: "Testimonials",
  href: "/#testimonials"
}, {
  label: "FAQ",
  href: "/#faq"
}, {
  label: "Portfolio",
  href: "/videos"
}];
export function SiteFooter() {
  return <footer className="relative overflow-hidden border-t border-white/10 bg-[#050808] px-5 pb-8 pt-16 text-white md:px-8" data-id="element-376" data-mp="38i1ifdpgj9bb">
      <div className="mx-auto max-w-[1480px]" data-id="element-377" data-mp="33jq5uv7s2kpe">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-378" data-mp="33ki1g61dkifo">
          <div className="lg:col-span-5" data-id="element-379" data-mp="2ykn87vu4ngrg">
            <Logo className="h-8 w-[72px]" data-id="element-380" data-mp="2ylydy174uyl7" />
            <p className="mt-7 font-mono text-[11px] uppercase tracking-[0.2em] text-[#54f6c6]" data-id="element-381" data-mp="11rk0to1cwlk6">End credits</p>
            <p className="mt-6 max-w-sm text-sm leading-7 text-white/65" data-id="element-382" data-mp="wtilne71x6dz">
              Senior 2D &amp; 3D Motion Designer and VFX Artist working across CGI, motion, compositing, and AI-assisted production.
            </p>
            <a href={links.calendly} target="_blank" rel="noreferrer" data-cursor="Book" className="mt-8 inline-flex min-h-11 items-center gap-3 border-b border-[#54f6c6] pb-2 text-sm text-white transition-colors hover:text-[#54f6c6] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-383" data-mp="1ar9k4t21udii">
              Book a call <ArrowUpRight className="h-4 w-4" aria-hidden="true" data-id="element-384" data-mp="1tgg4slmelf6y" />
            </a>
          </div>

          <nav aria-label="Footer" className="grid grid-cols-2 gap-8 text-sm lg:col-span-4" data-id="element-385" data-mp="1erjo606a6tuq">
            <div data-id="element-386" data-mp="1eppan6xca40o">
              <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/45" data-id="element-387" data-mp="1jqd3ly54ouxj">Index</p>
              <ul className="mt-2" data-id="element-388" data-mp="27fp8wmxc4iuk">
                {index.map(item => <li key={item.label} data-id="element-389" data-mp="27ee88vz6rr7o">
                    <a href={item.href} className="flex min-h-11 items-center text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-390" data-mp="2c7z6mp4oyn7e">{item.label}</a>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-391" data-mp="2d1g9gkw09ep8">
              <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/45" data-id="element-392" data-mp="2d0wwlil7pgi2">Contact</p>
              <ul className="mt-2" data-id="element-393" data-mp="282mx4vsgftqn">
                <li data-id="element-394" data-mp="2341vqt1gv40m"><a href={links.email} className="flex min-h-11 items-center break-words py-1 text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-395" data-mp="2341xaxh47c2q">s.m.zeeshan2233@gmail.com</a></li>
                <li data-id="element-396" data-mp="1tes41eajbnd1"><a href={links.whatsapp} target="_blank" rel="noreferrer" className="flex min-h-11 items-center text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-397" data-mp="1tes2h9uvzfax">+973 398 64230</a></li>
                <li data-id="element-398" data-mp="1fdxvmvnhlmed"><a href={links.linkedin} target="_blank" rel="noreferrer" className="flex min-h-11 items-center text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-399" data-mp="1fe7k2esvvlhy">LinkedIn</a></li>
              </ul>
            </div>
          </nav>

          <div className="lg:col-span-3 lg:text-right" data-id="element-400" data-mp="4ucquluoiyo6">
            <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/45" data-id="element-401" data-mp="4ss1dan825x6">Availability</p>
            <p className="mt-4 text-sm text-white/70" data-id="element-402" data-mp="38bbk9mk0fzfb">Booking new projects, worldwide</p>
            <LocalClock className="mt-2 block font-mono text-[11px] uppercase tracking-[0.16em] text-white/45" data-id="element-403" data-mp="389iavzi0j13m" />
            <a href="#top" className="mt-8 inline-flex min-h-11 items-center gap-2 text-sm uppercase tracking-[0.1em] text-white/70 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6]" data-id="element-404" data-mp="3hc18a4314lih">
              Back to top <ArrowUp className="h-4 w-4" aria-hidden="true" data-id="element-405" data-mp="2pkbwups5yxo5" />
            </a>
          </div>
        </div>

        <p aria-hidden="true" className="mt-16 select-none font-heading text-[clamp(2.4rem,9vw,7.5rem)] font-semibold lowercase leading-[0.82] tracking-[-0.06em] text-white/[0.055]" data-id="element-406" data-mp="2tkm19y0b5g0w">
          sm zeeshan
        </p>

        {/* Clears the floating pill nav, which sits ~104px off the bottom edge. */}
        <div className="mt-8 flex flex-col gap-3 border-t border-white/10 pb-32 pt-6 font-mono text-[11px] uppercase tracking-[0.14em] text-white/45 sm:flex-row sm:justify-between md:pb-36" data-id="element-407" data-mp="2k9q130y7bxjy">
          <span data-id="element-408" data-mp="2t6gv77t712bw">© {new Date().getFullYear()} SM Zeeshan · All rights reserved</span>
          <span data-id="element-409" data-mp="2o8fe2sfbvd32">Motion · CGI · VFX · Post-production</span>
        </div>
      </div>
    </footer>;
}